import React, { useEffect, useState } from 'react';
import Banner from "./Banner";
import BannerSelection from "./BannerSelection";
import Column from "./Column";
import {
    customerDetails,
    getPartnerData,
    setPrimaryColour,
    setPreparingPrimaryColour,
    setCompletedPrimaryColour,
    setFontFamily,
    statuses,
    // listStores,
    // logoutUsers,
    getLocalUserInfoLocalStorage,
    listTrades
} from "../utils/utils";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getDb } from "../firebase/Firebase";
import googlePlay from '../assets/uniform-google-play.png';
import appleLogo from '../assets/uniform-app-store.png';
import webLogo from '../assets/uniform-web-logo.png';
import { translate } from "../utils/translation";


function Board() {
    const params = getLocalUserInfoLocalStorage();
    const defaultBanner = params?.optionalResources?.find(resource => resource.isDefault);

    useEffect(() => {
        const rawMode = params?.displayMode || 'Default';
        const mode = rawMode.toString().toLowerCase().replace(/\s+/g, '-');
        const displayModeClass = `display-mode-${mode}`;
        const bodyClasses = Array.from(document.body.classList);
        bodyClasses
            .filter(className => className.startsWith('display-mode-'))
            .forEach(className => document.body.classList.remove(className));
        if (mode !== 'default') {
            document.body.classList.add(displayModeClass);
        }

        return () => {
            if (mode !== 'default') {
                document.body.classList.remove(displayModeClass);
            }
        };
    }, [params.displayMode]);

    const [customerDetailsTradeInfo, setCustomerDetails] = useState(null);
    const [trades, setTrades] = useState([]);
    const [bannerObject, setBannerObject] = useState(defaultBanner || { fileName: "", placeholderImageFilename: "", isVideoFile: false });
    const [showBannerSelection, setShowBannerSelection] = useState(false);
    const [logoFailed, setLogoFailed] = useState(false);
    const storeName = (params['storeNames'] || []).find(name => name && name.trim());
    const showStoreNameHeading = logoFailed && !!storeName;

    const partnerId = params['partnerId'];
    const language = params['defaultLanguage'] || 'en';
    const collectionPointName = params['collectionPointName'];
    const showCollectionPoint = params['showCollectionPoint'];
    const boardType = (params['type'] || 'Both').toLowerCase();
    const primaryColour = params['primaryColour'];
    const preparingPrimaryColour = params['preparingPrimaryColour'];
    const completedPrimaryColour = params['completedPrimaryColour'];
    const font = params['font'];
    const landScape = params['landScape'];
    const showLogo = params['showLogo'];
    const subIds = params['subIds']?.filter(el => el !== '').map(el => Number(el));
    const partnerData = getPartnerData(partnerId, params['logoChoice']) || {};
    let showDownload = params['showDownload'];
    const logoURL = params['logoURL'];
    if (!params['showLoyalty'] && partnerData.text) {
        partnerData.text = partnerData.text.replace("and earn rewards ", "");
    }
    let image = partnerData?.image || null;
    let buildingImage = '';
    if (logoURL && logoURL !== '') {
        buildingImage = logoURL;
    }
    if (partnerData?.partnerId === 19) {
        showDownload = false;
    }
    setPrimaryColour(primaryColour);
    setPreparingPrimaryColour(preparingPrimaryColour);
    setCompletedPrimaryColour(completedPrimaryColour);
    setFontFamily(font);

    const unsubscribeList = [];

    const unsubscribeAll = () => {
        if (!unsubscribeList || unsubscribeList.length === 0) {
            return;
        }
        unsubscribeList.forEach((unsubscribeFn) => {
            unsubscribeFn();
        });
    };

    const logoutToast = () => toast('Logging out as user does not have access to store.', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const addTrades = (tradesData) => {
        setTrades(trades => {
            let tradeList = Array.from(trades);
            tradesData.map(tradeData => {
                let ticketIndex = tradeList.findIndex((trade) => (trade.id === tradeData.id));
                if (ticketIndex > -1) {
                    tradeList[ticketIndex] = tradeData;
                } else {
                    tradeList.push(tradeData);
                }
            });
            const now = Date.now();
            // filter out tickets requested to be completed over 5 mins ago
            tradeList = tradeList.filter(trade => {
                if (!trade) {
                    return false;
                }
                if ([0, 1, 2, 3, 4, 7].indexOf(trade.type) < -1) {
                    return false;
                }
                if (trade.state === 6) {
                    if (trade.dequeueTime && now > (trade.dequeueTime || 0)) {
                        // ticket was scanned to complete, remove from display
                        return false;
                    }
                    if (trade.platform && trade.platform === 4) {
                        return now - (trade.actualCompletionTime || 0) < 1 * 60 * 1000;
                    }
                    return now - (trade.actualCompletionTime || 0) < 5 * 60 * 1000;
                } else {
                    return now - (trade.requestedCompletionTime || 0) < 10 * 60 * 1000;
                }
            });
            return [...tradeList];
        });
    };

    const processTrades = (tradesData) => {
        if (subIds.length === 0) {
            addTrades(tradesData);
            return;
        }

        const filteredTradesData = [];
        tradesData.map(tradeData => {
            // hide orders that don't get shown on KDS; shouldn't be shown on order status board either
            if (tradeData.entirelyHiddenFromKDS) {
                return;
            }

            if (tradeData.hasOwnProperty('menuItemSubCategoryIds')) {
                if (tradeData['menuItemSubCategoryIds'].some(subcategoryId => subIds.includes(subcategoryId))) {
                    filteredTradesData.push(tradeData);
                }
            } else {
                filteredTradesData.push(tradeData);
            }
        });
        addTrades(filteredTradesData);
    };

    useEffect(() => {
        (async () => {
            setCustomerDetails(null);
            let storeIds = params.storeIds;
            let storeAccess = true;
            // try {
            //     const storesData = await listStores(token);
            //     let storesDataIds = [];
            //     storesData['onlineStores'].map(store => {
            //         storesDataIds.push(store.id.toString());
            //     });
            //     storesData['offlineStores'].map(store => {
            //         storesDataIds.push(store.id.toString());
            //     });
            //     storesData['closedStores'].map(store => {
            //         storesDataIds.push(store.id.toString());
            //     });
            //     for (let storeId of storeIds) {
            //         if (!(storesDataIds.indexOf(storeId) > -1)) {
            //             storeAccess = false;
            //             break;
            //         }
            //     }
            // } catch (error) {
            //     storeAccess = false;
            // }
            if (!storeAccess) {
                logoutToast();
                // await logoutUsers(token)
                //     .then(() => {
                //         clearLocalStorage();
                //         setToken(null);
                //     }).catch(() => {
                //         clearLocalStorage();
                //         setToken(null);
                //     });
                return () => {};
            }

            const storeNames = params.storeNames.map(storeNames => storeNames.substring(0, 15));
            const storeInfo = {};
            storeIds.map((id, index) => storeInfo[id] = storeNames[index]);
            storeIds = storeIds.map(storeId => Number(storeId));
            const someTimeAgo = new Date();
            someTimeAgo.setMinutes(someTimeAgo.getMinutes() - 30);

            storeIds.map(storeId => {
                const db = getDb();
                if (!db) {
                    return;
                }
                const unsubscribe = db.collection('trades')
                    .where('tradeJson.storeId', '==', storeId)
                    .where('tradeJson.state', 'in', [0, 1, 2, 3, 4, 6])
                    .where('tradeJson.requestedCompletionTime', '>', someTimeAgo.getTime())
                    .orderBy('tradeJson.requestedCompletionTime', 'desc')
                    .limit(50)
                    .onSnapshot(snapshot => {
                        processTrades(snapshot.docs.map(doc => doc.data()['tradeJson']));
                    });
                unsubscribeList.push(unsubscribe);
            });

            const fetchLatestTradesInterval = setInterval(async () => {
                const tradesFromHttp = await listTrades(storeIds.toString());
                processTrades(tradesFromHttp); // API call
            }, 60 * 1000);

            // const refreshTradeListInterval = setInterval(() => {
            //     // add an empty array to trades array to prompt filtering by trade requestedCompletionTime
            //     addTrades([]);
            // }, 3 * 60 * 1000);

            // immediately trigger a trades HTTP fetch
            const tradesFromHttp = await listTrades(storeIds.toString());
            processTrades(tradesFromHttp);

            return () => {
                unsubscribeAll();
                // clearInterval(refreshTradeListInterval);
                clearInterval(fetchLatestTradesInterval);
            }
        })();
    }, []);

    useEffect(() => {
        if (trades.length !== 0) {
            const tradeIds = [];
            // eslint-disable-next-line array-callback-return
            trades.map(trade => {
                tradeIds.push(trade.id);
            });

            fetchData(tradeIds, params.storeIds);
        }
    }, [trades]);

    async function fetchData(tradeIds, storeIds) {
        const result = await customerDetails(tradeIds, storeIds);
        let currCustomerDetailsTradeInfo = null;
        if (Array.isArray(result)) {
            currCustomerDetailsTradeInfo = {};
            result.map(customer => {
                if (customer.firstName) {
                    if (["Epos", "Kiosk", "ANON"].indexOf(customer.firstName) >= 0 || customer.firstName.indexOf("@dynamify.com") >= 0) {
                        customer.firstName = "Guest";
                    }
                }
                currCustomerDetailsTradeInfo[customer.id] = customer;
            });
        }
        setCustomerDetails(currCustomerDetailsTradeInfo);
    }

    const setCSSColor = (status) => {
        let titleClassName = 'preparing';
        switch (status) {
            case statuses[0]:
                titleClassName = 'preparing';
                break;
            case statuses[1]:
                titleClassName = 'completed';
                break;
            default:
                break;
        }
        return titleClassName;
    };

    const setCSSColorText = (status, showDownload) => {
        if (showDownload) {
            return ''
        }
        let titleClassName = 'preparing';
        switch (status) {
            case statuses[0]:
                titleClassName = 'preparing';
                break;
            case statuses[1]:
                titleClassName = 'completed';
                break;
            default:
                break;
        }
        return titleClassName;
    };

    const showOptionalResources = () => {
        if (!params.optionalResources || !params.optionalResources.length) {
            toast(translate('NO_ADDITIONAL_RESOURCES', language), {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
            return;
        }

        if (params.optionalResources.length === 1) {
            selectBanner(params.optionalResources[0]);
        } else {
            setShowBannerSelection(true);
        }
    };

    const selectBanner = (obj) => {
        if (obj && obj.fileName) {
            setBannerObject(obj);
        }
        setShowBannerSelection(false);
    };

    const hideBanner = () => {
        setBannerObject({ fileName: "", isVideoFile: false });
    };

    const renderLogo = () => {
        if (logoFailed) {
            return '';
        }
        if (buildingImage) {
            return <img id={1} src={buildingImage} alt="store logo" className="image" onError={() => setLogoFailed(true)} />;
        }
        if (image) {
            return <img id={1} src={image} alt="store logo" className="image" onError={() => setLogoFailed(true)} />;
        }

        return '';
    };

    const statusesToShow = (() => {
        switch (boardType) {
            case 'preparing':
                return [statuses[0]];
            case 'ready':
                return [statuses[1]];
            default:
                return statuses;
        }
    })();

    return (
        <div>
            <div className="board" style={{ width: landScape ? '150%' : '100%' }}>
                {showLogo ?
                    <>{ renderLogo() }</>
                    : ''
                }
                <div className="status-wrapper">
                    {showCollectionPoint && collectionPointName ?
                        <div className="collection-point text-center">{collectionPointName}</div>
                        : ''
                    }
                    {showStoreNameHeading ?
                        <div className="store-name-heading text-center">{storeName}</div>
                        : ''
                    }
                    <div className="status-columns">
                        {
                            statusesToShow.map((status, index) =>
                                (
                                    <div key={status} className={`status-col ${setCSSColor(status)} ${statusesToShow.length === 1 ? 'single' : ''} ${showCollectionPoint && collectionPointName ? 'has-collection-point' : ''} ${showStoreNameHeading ? 'has-store-name' : ''}`}>
                                        <h1 className={`status-header ` + setCSSColorText(status, showDownload)}>
                                            {translate(status, language)}
                                        </h1>
                                        <div className="column-container">
                                            <Column key={status}
                                                    trades={trades}
                                                    landScape={landScape}
                                                    customerDetailsTradeInfo={customerDetailsTradeInfo}
                                                    status={status}
                                                    columnIndex={index}
                                            />
                                        </div>
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>
            <div className='text-center bottom-text'>
                {showDownload === true ? partnerData?.text : ''}
            </div>
            <div className="footer">
                {showDownload === true ? partnerData?.googlePlay ?
                    <a href={partnerData?.googlePlay} target="_blank" rel="noopener noreferrer" title="google play logo">
                        <img src={googlePlay} className="logo" alt="google play store" />
                    </a>
                    : '' : ''
                }

                {showDownload === true ? partnerData?.appStore ?
                    <a href={partnerData?.appStore} target="_blank" rel="noopener noreferrer" title="app store logo">
                        <img src={appleLogo} className="logo" alt="app store logo" />
                    </a>
                    : '' : ''
                }

                {showDownload === true ? partnerData?.website ?
                    <a href={partnerData?.website} target="_blank" rel="noopener noreferrer" title="web logo">
                        <img src={webLogo} className="logo" alt="web logo" />
                    </a>
                    : '' : ''
                }

            </div>

            {params.optionalResources && params.optionalResources.length ?
                <div className='optional-resources-link' onClick={showOptionalResources}>
                    <i className="fa fa-bars fa-2x"></i>
                </div>
                : ''
            }

            {showBannerSelection ?
                <BannerSelection
                    resources={params.optionalResources}
                    selectBanner={selectBanner}
                />
                : ''
            }

            {bannerObject && bannerObject.fileName ?
                <Banner
                    bannerObject={bannerObject}
                    hideBanner={hideBanner}
                />
                : ''
            }
        </div>

    )

}

export default (Board);
